import React, { createContext, ReactNode, useState } from 'react';

type AppContextType = {
  isAccountsLengthChanged: boolean;
  isFullScreen: boolean;
  hasOverlay?: boolean;
};

export const AppContext = createContext<{
  state: AppContextType;
  triggerAccountsLengthChange?: () => void;
  triggerIsFullScreen?: (isFullScreen: boolean) => void;
  triggerHasOverlay?: (hasOverlay: boolean) => void;
  clearTrigger?: () => void;
}>({
  state: {
    isAccountsLengthChanged: false,
    isFullScreen: false,
    hasOverlay: false,
  },
  triggerAccountsLengthChange: undefined,
  triggerIsFullScreen: undefined,
  triggerHasOverlay: undefined,
  clearTrigger: undefined,
});

export const AppContextComponent: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [state, setState] = useState<AppContextType>({
    isAccountsLengthChanged: false,
    isFullScreen: false,
  });

  const handleTriggerAccountsLengthChange = () => {
    setState((state) => ({ ...state, isAccountsLengthChanged: true }));
  };
  const handleClearTrigger = () => {
    setState((state) => ({ ...state, isAccountsLengthChanged: false }));
  };

  const handleTriggerIsFullScreen = (isFullScreen: boolean) => {
    setState((state) => ({ ...state, isFullScreen }));
  };

  const handleTriggerHasOverlay = (hasOverlay: boolean) => {
    setState((state) => ({ ...state, hasOverlay }));
  };

  return (
    <AppContext.Provider
      value={{
        state,
        triggerAccountsLengthChange: handleTriggerAccountsLengthChange,
        triggerIsFullScreen: handleTriggerIsFullScreen,
        triggerHasOverlay: handleTriggerHasOverlay,
        clearTrigger: handleClearTrigger,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
